//@ts-check
// eslint-disable-next-line no-unused-vars
class Configuration {
  /**
   * @typedef Configurations
   * @type {Object}
   * @property {String} ENV - Environnement courant
   * @property {Boolean} authenfication - authentification Auth0
   * @property {String} urlAssurabiliteBFF - urlAssurabiliteBFF
   * @property {String} urlClickToCallDesktopFR - urlClickToCallDesktopFR
   * @property {String} urlClickToCallDesktopEN - urlClickToCallDesktopEN
   * @property {String} urlClickToCallMobileFR - urlClickToCallDesktopFR
   * @property {String} urlClickToCallMobileEN - urlClickToCallDesktopEN
   * @property {String} urlClickToCallDesktopFR_AMC - urlClickToCallDesktopFR_AMC
   * @property {String} urlClickToCallDesktopEN_AMC - urlClickToCallDesktopEN_AMC
   * @property {String} urlClickToCallMobileFR_AMC - urlClickToCallDesktopFR_AMC
   * @property {String} urlClickToCallMobileEN_AMC - urlClickToCallDesktopEN_AMC
   * @property {String} urlSommaire - urlSommaire
   * @property {String} [envSoa] - environnement SOA
   * @property {Array<Object>} consommateurCallBackInfos - consommateurCallBackInfos
   */

  constructor() {
    this.env =
      // @ts-ignore
      typeof window !== "undefined" &&
      // @ts-ignore
      typeof window["envvars"] !== "undefined" &&
      // @ts-ignore
      typeof window["envvars"].REACT_APP_ENV !== "undefined"
        ? // @ts-ignore
          String(window["envvars"].REACT_APP_ENV)
        : "prod";

    this.configurationsForAllEnvironments = this.obtenirConfigurationsForAllEnvironments();
  }

  /**
   * Pour obtenir les configurations de l'environnement courant
   * @returns {Configurations}
   */
  obtenirConfigurations() {
    /** @type {Configurations} **/
    return this.configurationsForAllEnvironments[this.env];
  }

  /**
   * Pour obtenir les configurations de l'environnement courant
   * @returns {Object.<string, Configurations>}
   */
  obtenirConfigurationsForAllEnvironments() {
    return {
      /** @type {Configurations} **/
      local: {
        ENV: "local",
        authenfication: false,
        // @ts-ignore
        urlAssurabiliteBFF:
          "https://wiremock-assurabilite-dev-dev.apps.apaas.caea.azure.nprodcloud.desjardins.com/Assurabilite-BFF/v1",
        //urlAssurabiliteBFF: "https://assurabilite-bff-dev-ass-part-select-risque.apps.cfzcea.dev.desjardins.com",
        urlClickToCallDesktopFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-full-page",
        urlClickToCallMobileEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/mobile-services",
        urlClickToCallMobileFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb-martine.mouvdev.desjardins.com:443/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "d1c8c1fc-6991-4f2c-b791-30d3cc459eb6",
            description: "RHN - DEV",
            url: "https://front-web-dev-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "33d2a6c7-f4de-4dc8-8cea-199c51abce68",
            description: "RHN - QA",
            url: "https://front-web-qa-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "6c472c2a-e8e0-4dee-9406-4677415ee9c8",
            description: "RHN - HA",
            url: "https://front-web-ha-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "f2d71a50-747a-4556-b232-3e8a9bc305ae",
            description: "Assurance credit",
            url: "https://assurancecreditepargne.assurancevie.dev.desjardins.com/",
          },
          {
            idCallback: "2685f90d-3da5-4ba3-8180-65db0533e307",
            description: "SPA Souscription - DEV",
            url: "https://assurancecreditepargne-adhesion.dev.desjardins.com/",
          },
          {
            idCallback: "0a16edf6-6d9a-4c72-a6e2-2b15b20391ab",
            description: "SPA Souscription - DEV - EN",
            url: "https://creditsavingsinsurance-adhesion.dev.desjardins.com/",
          },
          {
            idCallback: "c7b5a731-0147-4874-89d6-04fb297d83fd",
            description: "Assurance Marge Credit - DEV - FR",
            url: "https://assurancemargecredit-dev.desjardins.com/"
          },
          {
            idCallback: "ec3372a0-a599-4078-87cb-0d883ffaad8d",
            description: "Assurance Marge Credit - DEV - EN",
            url: "https://creditmargininsurance-dev.desjardins.com/"
          }
        ],
      },
      dev: {
        ENV: "dev",
        authenfication: false,
        // @ts-ignore
        urlAssurabiliteBFF:
          "https://wiremock-assurabilite-dev-dev.apps.apaas.caea.azure.nprodcloud.desjardins.com/Assurabilite-BFF/v1",
        urlClickToCallDesktopFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-full-page",
        urlClickToCallMobileEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/mobile-services",
        urlClickToCallMobileFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb-martine.mouvdev.desjardins.com:443/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "d1c8c1fc-6991-4f2c-b791-30d3cc459eb6",
            description: "RHN - DEV",
            url: "https://front-web-dev-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "33d2a6c7-f4de-4dc8-8cea-199c51abce68",
            description: "RHN - QA",
            url: "https://front-web-qa-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "6c472c2a-e8e0-4dee-9406-4677415ee9c8",
            description: "RHN - HA",
            url: "https://front-web-ha-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "f2d71a50-747a-4556-b232-3e8a9bc305ae",
            description: "Assurance credit",
            url: "https://assurancecreditepargne.assurancevie.dev.desjardins.com/",
          },
          {
            idCallback: "2685f90d-3da5-4ba3-8180-65db0533e307",
            description: "SPA Souscription - DEV - FR",
            url: "https://assurancecreditepargne-adhesion.dev.desjardins.com/",
          },
          {
            idCallback: "0a16edf6-6d9a-4c72-a6e2-2b15b20391ab",
            description: "SPA Souscription - DEV - EN",
            url: "https://creditsavingsinsurance-adhesion.dev.desjardins.com/",
          },
          {
            idCallback: "c7b5a731-0147-4874-89d6-04fb297d83fd",
            description: "Assurance Marge Credit - DEV - FR",
            url: "https://assurancemargecredit-dev.desjardins.com/"
          },
          {
            idCallback: "ec3372a0-a599-4078-87cb-0d883ffaad8d",
            description: "Assurance Marge Credit - DEV - EN",
            url: "https://creditmargininsurance-dev.desjardins.com/"
          }
        ],
      },
      /** @type {Configurations} **/
      certification: {
        ENV: "certification",
        authenfication: true,
        urlAssurabiliteBFF: "https://api-azr-dev-d.desjardins.com/api/assurance-particuliers/bff-assurabilite/v1",
        urlClickToCallDesktopFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-full-page",
        urlClickToCallMobileEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/mobile-services",
        urlClickToCallMobileFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb-01-20494.mouvdev.desjardins.com:443/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "d1c8c1fc-6991-4f2c-b791-30d3cc459eb6",
            description: "RHN - DEV",
            url: "https://front-web-dev-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "33d2a6c7-f4de-4dc8-8cea-199c51abce68",
            description: "RHN - QA",
            url: "https://front-web-qa-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "6c472c2a-e8e0-4dee-9406-4677415ee9c8",
            description: "RHN - HA",
            url: "https://front-web-ha-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "056cc115-1e32-4493-8767-872515e072b5",
            description: "Assurance credit",
            url: "https://soumission-assurance-produit-financier-spa-acceptation.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
          },
          {
            idCallback: "f2d71a50-747a-4556-b232-3e8a9bc305ae",
            description: "Assurance credit",
            url: "https://assurancecreditepargne.assurancevie.dev.desjardins.com/",
          },
          {
            idCallback: "700037b4-55cf-4828-a53a-2c0bad32ed7c",
            description: "SPA Souscription - CERTIF - FR",
            url: "https://assurancecreditepargne-adhesion.certif.desjardins.com/",
          },
          {
            idCallback: "ecc8725c-9844-4858-9c17-bf562bf60712",
            description: "SPA Souscription - CERTIF - EN",
            url: "https://creditsavingsinsurance-adhesion.certif.desjardins.com/",
          },
          {
            idCallback: "7d2704a3-b75a-40cb-b0e7-c30d9a139139",
            description: "SPA Souscription - DEMO - FR",
            url: "https://octroi-spa-demo.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "ef76189c-4a13-4be2-85dc-a53b5cca13a2",
            description: "SPA Souscription - DEMO - EN",
            url: "https://octroi-spa-demo.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "92f8c7b8-e49c-4644-aae9-d20e1fb9dbf7",
            description: "SPA Souscription - CERTIF - FR",
            url: "https://octroi-spa-certif.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "5302fc8a-55b7-43ce-88a5-016b392262e0",
            description: "SPA Souscription - CERTIF - EN",
            url: "https://octroi-spa-certif.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "b7e2c1a2-4e2a-4b7a-9c1d-2e8f3a7b1c4d",
            description: "SPA Souscription - HOT FIX - FR",
            url: "https://octroi-spa-hotfix.apps.cfzcea.dev.desjardins.com/",
            envSoa: "Maint"
          },
          {
            idCallback: "f3a9b2c7-1d4e-4a2b-8c7e-9b2a1d3e4f5c",
            description: "SPA Souscription - HOT FIX - EN",
            url: "https://octroi-spa-hotfix.apps.cfzcea.dev.desjardins.com/",
            envSoa: "Maint"
          },
          {
            idCallback: "d44b615c-62e3-43ed-95da-cd1c21c2201d",
            description: "Assurance Marge Credit - CERTIF - FR",
            url: "https://assurance-marge-credit-certif.apps.cfzcea.dev.desjardins.com/"
          },
          {
            idCallback: "9c3c6cf9-7a3c-49db-8593-172bea91adf6",
            description: "Assurance Marge Credit - CERTIF - EN",
            url: "https://assurance-marge-credit-certif.apps.cfzcea.dev.desjardins.com/"
          },
          {
            idCallback: "8aef4e31-f0d3-46b7-bd45-3bf4b293774f",
            description: "Assurance Marge Credit - DEMO - FR",
            url: "https://assurance-marge-credit-demo.apps.cfzcea.dev.desjardins.com/"
          },
          {
            idCallback: "73113969-b7ce-47d1-8ed1-11d82b564a63",
            description: "Assurance Marge Credit - DEMO - EN",
            url: "https://assurance-marge-credit-demo.apps.cfzcea.dev.desjardins.com/"
          },
          {
            "idCallback": "b945445c-7dc4-4d4d-9217-9389ec0f2955",
            "description": "Assurance Marge Credit - DEMO - ARO - FR",
            "url": "https://assurance-marge-credit-demo.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "21ac13b9-f90b-457a-97dd-985cd6a1485c",
            "description": "Assurance Marge Credit - DEMO - ARO - EN",
            "url": "https://assurance-marge-credit-demo.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "7afb27ad-1c19-46c8-95a7-db423557f0eb",
            "description": "Assurance Marge Credit - CERTIF - ARO - FR",
            "url": "https://assurance-marge-credit-certif.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "dc028cf0-9e33-4869-87c1-716565009c0b",
            "description": "Assurance Marge Credit - CERTIF - ARO - EN",
            "url": "https://assurance-marge-credit-certif.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "a5892dc0-2fb4-4e85-8bc9-71e757423204",
            "description": "Assurance Marge Credit - HOTFIX - PAAS - FR",
            "url": "https://assurance-marge-credit-hotfix.apps.cfzcea.dev.desjardins.com/"
          },
          {
            "idCallback": "bc45b011-5ea7-4062-a96b-306c0204ca1d",
            "description": "Assurance Marge Credit - HOTFIX - PAAS - EN",
            "url": "https://assurance-marge-credit-hotfix.apps.cfzcea.dev.desjardins.com/"
          },
          {
            "idCallback": "a8cbacee-a010-48a4-96aa-c4d9f524011b",
            "description": "Assurance Marge Credit - HOTFIX - ARO - FR",
            "url": "https://assurance-marge-credit-hotfix.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
            "envSoa": "Maint"
          },
          {
            "idCallback": "6ab10a89-0a96-4b15-a486-123804905f59",
            "description": "Assurance Marge Credit - HOTFIX - ARO - EN",
            "url": "https://assurance-marge-credit-hotfix.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
            "envSoa": "Maint"
          },
          {
            "idCallback": "3982c76a-4d88-47b8-ae37-b91715ca163e",
            "description": "Assurance Marge Credit - VS - ARO - FR",
            "url": "https://assurancemargecredit.certif.desjardins.com/"
          },
          {
            "idCallback": "210701ad-b46f-438b-902e-f32751fe19f1",
            "description": "Assurance Marge Credit - VS - ARO - EN",
            "url": "https://creditmargininsurance.certif.desjardins.com/"
          },
          {
            "idCallback": "83a49b2f-1660-43f2-bf33-6214a1c10790",
            "description": "OCTROI - DEMO - ARO - FR",
            "url": "https://octroi-spa-demo.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "b8b3afcc-0f93-4481-b609-6b8b111b8024",
            "description": "OCTROI - DEMO - ARO - EN",
            "url": "https://octroi-spa-demo.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },

          {
            "idCallback": "ba3950c0-7fb5-410e-bf6e-3dc5d937a14f",
            "description": "OCTROI - HOTFIX - ARO - FR",
            "url": "https://octroi-spa-hotfix.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
            "envSoa": "Maint"
          },

         {
            "idCallback": "a4f7f7e0-e6db-4c26-b14a-143baf58ada7",
            "description": "OCTROI - HOTFIX - ARO - EN",
            "url": "https://octroi-spa-hotfix.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
            "envSoa": "Maint"
          },
          {
            "idCallback": "32181cac-de6d-4eba-b857-f7214a458506",
            "description": "OCTROI - CERTIF - FR",
            "url": "https://octroi-spa-certif.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },

          {
            "idCallback": "9a318a9e-98e8-4f75-b6a2-2170257f915b",
            "description": "OCTROI - CERTIF - EN",
            "url": "https://octroi-spa-certif.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },

          {
            "idCallback": "cfa1f74c-802d-47a5-83e5-6a5b1ee1aa1e",
            "description": "OCTROI - UAT - FR",
            "url": "https://octroi-spa-uat.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          },
          {
            "idCallback": "fe6cbdad-c4e3-4ac8-8a96-d887889fb8d8",
            "description": "OCTROI - UAT - EN",
            "url": "https://octroi-spa-uat.apps.apaas.caea.azure.nprodcloud.desjardins.com/"
          }
        ],
      },
      /** @type {Configurations} **/
      integre: {
        ENV: "integre",
        authenfication: true,
        urlAssurabiliteBFF: "https://api-azr-dev-d.desjardins.com/api/assurance-particuliers/bff-assurabilite/v1",
        urlClickToCallDesktopFR: "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN: "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN: "https://rappel.desjardins.com/slkfgndflgmds#/mobile-services",
        urlClickToCallMobileFR: "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb-01-20494.mouvdev.desjardins.com:443/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "d1c8c1fc-6991-4f2c-b791-30d3cc459eb6",
            description: "RHN - DEV",
            url: "https://front-web-dev-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "33d2a6c7-f4de-4dc8-8cea-199c51abce68",
            description: "RHN - QA",
            url: "https://front-web-qa-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "6c472c2a-e8e0-4dee-9406-4677415ee9c8",
            description: "RHN - HA",
            url: "https://front-web-ha-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "056cc115-1e32-4493-8767-872515e072b5",
            description: "Assurance credit",
            url: "https://soumission-assurance-produit-financier-spa-acceptation.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
          },
          {
            idCallback: "f2d71a50-747a-4556-b232-3e8a9bc305ae",
            description: "Assurance credit",
            url: "https://assurancecreditepargne.assurancevie.dev.desjardins.com/",
          },
          {
            idCallback: "700037b4-55cf-4828-a53a-2c0bad32ed7c",
            description: "SPA Souscription - CERTIF - FR",
            url: "https://octroi-spa-uat.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "ecc8725c-9844-4858-9c17-bf562bf60712",
            description: "SPA Souscription - CERTIF - EN",
            url: "https://octroi-spa-uat.apps.cfzcea.dev.desjardins.com/",
          },
          {
            idCallback: "d44b615c-62e3-43ed-95da-cd1c21c2201d",
            description: "Assurance Marge Credit - CERTIF - FR",
            url: "https://assurance-marge-credit-certif.apps.cfzcea.dev.desjardins.com/"
          },
          {
            idCallback: "9c3c6cf9-7a3c-49db-8593-172bea91adf6",
            description: "Assurance Marge Credit - CERTIF - EN",
            url: "https://credit-margin-insurance-certif.apps.cfzcea.dev.desjardins.com/"
          }
        ],
      },
      /** @type {Configurations} **/
      preprod: {
        ENV: "preprod",
        authenfication: true,
        urlAssurabiliteBFF: "https://api-azr-pp.desjardins.com/api/assurance-particuliers/bff-assurabilite/v1",
        urlClickToCallDesktopFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/dcom-full-page",
        urlClickToCallMobileEN:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/mobile-services",
        urlClickToCallMobileFR:
          "https://projet-dcom-ng-click2call-dev.apps.cfzcea.dev.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb-martine.mouvdev.desjardins.com:443/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "d1c8c1fc-6991-4f2c-b791-30d3cc459eb6",
            description: "RHN - DEV",
            url: "https://front-web-dev-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "33d2a6c7-f4de-4dc8-8cea-199c51abce68",
            description: "RHN - QA",
            url: "https://front-web-qa-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "6c472c2a-e8e0-4dee-9406-4677415ee9c8",
            description: "RHN - HA",
            url: "https://front-web-ha-parcours-habitation.cfzcea.mouvdev.desjardins.com/",
          },
          {
            idCallback: "056cc115-1e32-4493-8767-872515e072b5",
            description: "Assurance credit",
            url: "https://soumission-assurance-produit-financier-spa-acceptation.apps.apaas.caea.azure.nprodcloud.desjardins.com/",
          },
          {
            idCallback: "700037b4-55cf-4828-a53a-2c0bad32ed7c",
            description: "SPA Souscription - CERTIF - FR",
            url: "https://assurancecreditepargne-adhesion.certif.desjardins.com/",
          },
          {
            idCallback: "ecc8725c-9844-4858-9c17-bf562bf60712",
            description: "SPA Souscription - CERTIF - EN",
            url: "https://creditsavingsinsurance-adhesion.certi.desjardins.com/",
          },
          {
            idCallback: "d44b615c-62e3-43ed-95da-cd1c21c2201d",
            description: "Assurance Marge Credit - CERTIF - FR",
            url: "https://assurance-marge-credit-certif.apps.cfzcea.dev.desjardins.com/"

          },
          {
            idCallback: "9c3c6cf9-7a3c-49db-8593-172bea91adf6",
            description: "Assurance Marge Credit - CERTIF - EN",
            url: "https://credit-margin-insurance-certif.apps.cfzcea.dev.desjardins.com/"
          }
        ],
        envSoa: "Maint"
      },
      /** @type {Configurations} **/
      prod: {
        ENV: "prod",
        authenfication: true,
        urlAssurabiliteBFF: "https://api-azr.desjardins.com/api/assurance-particuliers/bff-assurabilite/v1",
        urlClickToCallDesktopFR: "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN: "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN: "https://rappel.desjardins.com/slkfgndflgmds#/mobile-services",
        urlClickToCallMobileFR: "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallDesktopFR_AMC:
          "https://rappel.desjardins.com/#/dcom-pleine-page",
        urlClickToCallDesktopEN_AMC:
          "https://rappel.desjardins.com/slkfgndflgmds#/dcom-full-page",
        urlClickToCallMobileEN_AMC:
          "https://rappel.desjardins.com/#/services-mobiles",
        urlClickToCallMobileFR_AMC:
          "https://rappel.desjardins.com/#/mobile-services",
        urlSommaire: "https://accweb.mouv.desjardins.com/identifiantunique/sso/redirect",
        consommateurCallBackInfos: [
          {
            idCallback: "e8a5ebf4-6507-47dd-9386-020c2901b108",
            description: "RHN - PROD",
            url: "https://renouvellement-hypothecaire.accesd.mouv.desjardins.com/",
          },
          {
            idCallback: "02f7e7a7-4cca-4a0f-bbea-ba851bfafa09",
            description: "Assurance credit",
            url: "https://assurancecreditepargne.assurancevie.desjardins.com/",
          },
          {
            idCallback: "23b2640a-ae39-4d3d-9bf7-8835a095e327",
            description: "SPA Souscription - PROD - FR",
            url: "https://assurancecreditepargne-adhesion.desjardins.com/",
          },
          {
            idCallback: "0642148b-b359-48a5-ab8e-1e8ed4a9a256",
            description: "SPA Souscription - PROD - EN",
            url: "https://creditsavingsinsurance-adhesion.desjardins.com/",
          },
          {
            idCallback: "8ace4dbe-d92e-4531-bfb1-3b0d2801df63",
            description: "Assurance Marge Credit - PROD - FR",
            url: "https://assurancemargecredit.desjardins.com/"
          },
          {
            idCallback: "6afaf953-ca37-4e1b-b81b-1ef095f4d602",
            description: "Assurance Marge Credit - PROD - EN",
            url: "https://creditmargininsurance.desjardins.com/"
          }
        ],
      },
    };
  }
}
const config = new Configuration();

export default config;
